// src/config/appConfig.js
// Centralized configuration - sensitive values should be set via environment variables in production

import {
  REFERRAL_COMMISSION_MAX_LEVELS,
  REFERRAL_COMMISSION_RATES,
  REFERRAL_COMPANY_ROYALTY_PERCENT,
} from "./referralCommissionConfig";

/**
 * Application Configuration
 * 
 * SECURITY NOTE: 
 * - In production, set REACT_APP_ADMIN_EMAIL environment variable
 * - Never commit actual admin emails to source control
 * - Use environment-specific .env files (.env.production, .env.development)
 */

// Admin configuration
export const ADMIN_CONFIG = {
  // Admin email - loaded from environment variable or fallback
  // Set REACT_APP_ADMIN_EMAIL in your .env file
  adminEmail: process.env.REACT_APP_ADMIN_EMAIL || "infinitywhale08@gmail.com",
  
  // Check if a user is admin
  isAdmin: (userEmail) => {
    if (!userEmail) return false;
    const adminEmail = ADMIN_CONFIG.adminEmail;
    return userEmail.toLowerCase() === adminEmail.toLowerCase();
  },
};

// App metadata
export const APP_CONFIG = {
  appName: "InfinityWhale",
  supportEmail: "support@infinitywhale.com",
  version: "1.0.0",
};

export const COMMISSION_CONFIG = {
  maxLevels: REFERRAL_COMMISSION_MAX_LEVELS,
  rates: REFERRAL_COMMISSION_RATES,
  companyRoyaltyPercent: REFERRAL_COMPANY_ROYALTY_PERCENT,
};

export default {
  ADMIN_CONFIG,
  APP_CONFIG,
  COMMISSION_CONFIG,
};



